import { useCallback, useRef, useState } from 'react';
import styled from 'styled-components';
import { CANDY_APPLE, LORAX } from 'HubStyleTokens/colors';
import globalNavHeight from 'nav-meta/global-nav-height';
import CoreMobileSearchBar from 'ecosystem-marketplace-core/components/storefront/MobileSearchBar';
// @ts-expect-error module is untyped
import MobilePanel from 'ecosystem-marketplace-core/js/components/mobile/MobilePanel';
import MobilePanelBody from 'ecosystem-marketplace-core/js/components/mobile/MobilePanelBody';
import MobileTypeaheadResults from 'marketplace-ui-common/components/mobile/MobileTypeaheadResults';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledStickySearchBarWrapper = styled.div.withConfig({
  displayName: "MobileSearchBar__StyledStickySearchBarWrapper",
  componentId: "sc-1y4wtt4-0"
})(["&&{position:fixed;z-index:9999;top:0;left:0;width:100%;height:", ";padding:5px 8px;background-image:linear-gradient(-303deg,", ",", ");}"], globalNavHeight, CANDY_APPLE, LORAX);
function MobileSearchBar({
  loadOptions,
  onClearSearch,
  onSearchSubmit,
  onSelectedOptionChange,
  placeholder,
  searchTerm
}) {
  const [input, setInput] = useState(searchTerm);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [results, setResults] = useState([]);
  const [mobileSearchBarFocused, setMobileSearchBarFocused] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [mobileSearchBarButtonFocused, setMobileSearchBarButtonFocused] = useState(false);
  const innerSearchBarRef = useRef(null);
  const handleSearchSubmit = () => {
    setIsPanelOpen(false);
    onSearchSubmit(input);
    setMobileSearchBarButtonFocused(true);
  };
  const fetchTypeaheadResults = search => loadOptions(search.toLowerCase(), (__, {
    options
  }) => setResults(options));
  const handleSearchUpdate = value => {
    setInput(value);
    fetchTypeaheadResults(value);
  };
  const handleSearchFocus = () => {
    setMobileSearchBarFocused(true);
    setIsPanelOpen(true);
    if (input.length) fetchTypeaheadResults(input);
  };
  const cancelMobileSearch = useCallback(() => {
    setMobileSearchBarFocused(false);
    setIsPanelOpen(false);
  }, []);
  const focusInnerSearchOnPanelOpen = useCallback(() => {
    const innerSearchBar = innerSearchBarRef.current;
    if (innerSearchBar) {
      const innerSearchInput = innerSearchBar.querySelector('.mobile-search-input');
      if (innerSearchInput) {
        innerSearchInput.focus();
        setMobileSearchBarButtonFocused(false);
      }
    }
  }, []);
  const focusOuterSearchOnPanelClose = useCallback(() => {
    setMobileSearchBarButtonFocused(true);
  }, []);
  const onPanelOpen = useCallback(() => {
    setScrollPosition(window.scrollY);
    window.onscroll = () => {
      window.scrollTo(0, 0);
    };
  }, []);
  const onPanelClose = useCallback(() => {
    window.onscroll = () => {};
    window.scrollTo(0, scrollPosition);
  }, [scrollPosition]);
  const handleOptionSelected = item => {
    onClearSearch();
    setIsPanelOpen(false);
    setMobileSearchBarFocused(false);
    setMobileSearchBarButtonFocused(true);
    onSelectedOptionChange(item);
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(CoreMobileSearchBar, {
      ariaLabel: placeholder,
      buttonFocused: mobileSearchBarButtonFocused,
      focused: false,
      inputValue: input,
      onClear: onClearSearch,
      onClick: handleSearchFocus,
      onSearchSubmit: handleSearchSubmit,
      placeholder: placeholder,
      use: "placeholder"
    }), /*#__PURE__*/_jsx(MobilePanel, {
      align: "top",
      open: isPanelOpen,
      onOpenComplete: focusInnerSearchOnPanelOpen,
      onOpenStart: onPanelOpen,
      onCloseComplete: focusOuterSearchOnPanelClose,
      onCloseStart: onPanelClose,
      children: /*#__PURE__*/_jsxs(MobilePanelBody, {
        ref: innerSearchBarRef,
        children: [/*#__PURE__*/_jsx(StyledStickySearchBarWrapper, {
          children: /*#__PURE__*/_jsx(CoreMobileSearchBar, {
            ariaLabel: placeholder,
            cancelSearch: cancelMobileSearch,
            focused: mobileSearchBarFocused || isPanelOpen,
            inputValue: input,
            onClear: onClearSearch,
            onSearchSubmit: handleSearchSubmit,
            onSearchUpdate: handleSearchUpdate,
            placeholder: placeholder
          })
        }), /*#__PURE__*/_jsx(MobileTypeaheadResults, {
          options: results,
          onChange: handleOptionSelected
        })]
      })
    })]
  });
}
export default MobileSearchBar;